import type { JSX } from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { UserAvatar } from '@/components/atoms/UserAvatar';
import { SuperAdminActions } from './SuperAdminActions';
import type { SuperAdmin } from '../types/super-admin.types';

interface SuperAdminCardProps {
  superAdmin: SuperAdmin;
  isCurrentUser?: boolean | undefined;
  onEdit: (superAdmin: SuperAdmin) => void;
}

export function SuperAdminCard({
  superAdmin,
  isCurrentUser,
  onEdit,
}: SuperAdminCardProps): JSX.Element {
  const statusVariant = superAdmin.isActive ? 'default' : 'secondary';
  const statusLabel = superAdmin.isActive ? 'Active' : 'Inactive';

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div className="flex items-center gap-3">
          <UserAvatar
            fullName={superAdmin.profile.fullName}
            photoUrl={superAdmin.profile.photoUrl}
            className="h-10 w-10"
          />
          <div className="flex flex-col gap-1">
            <span className="font-semibold text-lg">{superAdmin.profile.fullName}</span>
            <p className="text-sm text-muted-foreground">{superAdmin.email}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={statusVariant}>{statusLabel}</Badge>
          <SuperAdminActions
            superAdmin={superAdmin}
            onEdit={onEdit}
            isCurrentUser={isCurrentUser}
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-2">
          <Badge variant="outline" className="w-fit">
            SUPER_ADMIN
          </Badge>
          <p className="text-xs text-muted-foreground">
            Created: {new Date(superAdmin.createdAt).toLocaleDateString()}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
